const api_host=process.env.REACT_APP_API
const api_auth=process.env.REACT_APP_API_AUTH
export const getSpecial = (objective,user, token, month = null, year = null) =>  {
    const dateFilter = !month || !year ? '' : `&month=${month}&year=${year}`
    return fetch(api_host+`/reporte/indicadores/especial/getSpecial/?user=${user}&token=${token}&objectiveId=${objective}${dateFilter}`)
    .then(response => response.json())
}

export const getSpecialMethod = (objective, user, token, method, month, year, ...args) =>
    fetch(api_host+`/reporte/indicadores/especial/getSpecial/?user=${user}&token=${token}&objectiveId=${objective}&month=${month}&year=${year}&method=${method}&key=${api_auth}&args=${args}`)
.then(response => response.json())
